import React from "react";
import RaiseQueryPageMIS from "./components/RaiseQueryMIS";
import { ToastContainer } from "react-toastify";

const RaiseQueryMIS = () => {
  return (
    <div className="page-wrapper">
      <RaiseQueryPageMIS />

      <ToastContainer position="top-left" autoClose={3000} />
    </div>
  );
};

export default RaiseQueryMIS;
